var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemesWhiteColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35772 1.5H11.6424C12.1175 1.5 12.5 1.8825 12.5 2.35763L12.3454 7.3301H3.59426L3.50012 2.35763C3.49209 1.88257 3.88259 1.5 4.35772 1.5Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3454 7.33008V8.87388C12.4028 9.50215 11.6345 9.49465 11.1361 9.49725C9.30486 9.50668 8.9248 10.3529 8.9797 11.261C9.03153 12.1182 9.04523 12.2269 9.057 12.7106C9.08533 13.8731 8.5253 14.5 7.9698 14.5C7.4143 14.5 6.8543 13.8731 6.88263 12.7106C6.89443 12.2268 6.90813 12.1181 6.95993 11.261C7.01483 10.3529 6.63476 9.50665 4.80353 9.49725C4.3052 9.49465 3.5368 9.50218 3.59423 8.87388V7.33008",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesWhiteColor);
export default __webpack_public_path__ + "static/media/ThemesWhiteColor.cba7067e44a0d1aacf715b936506488d.svg";
export { ForwardRef as ReactComponent };